'use strict';

export function applyDayAria(container) {
    if (!container) {
        return;
    }
    container.querySelectorAll('.day').forEach(function (dayEl) {
        var ts = parseInt(dayEl.dataset.time, 10);
        if (!isNaN(ts)) {
            dayEl.setAttribute('role', 'button');
            dayEl.setAttribute('aria-label', new Date(ts).toLocaleDateString('it-IT', {
                weekday: 'long',
                day: 'numeric',
                month: 'long',
                year: 'numeric'
            }));
        }
        var unavailable = dayEl.classList.contains('locked')
            || dayEl.classList.contains('not-available');
        dayEl.setAttribute('aria-disabled', unavailable ? 'true' : 'false');
        var selected = dayEl.classList.contains('start')
            || dayEl.classList.contains('end')
            || dayEl.classList.contains('selected');
        dayEl.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
}

export function bindGridBridge(picker) {
    if (!picker || !picker.ui || !picker.ui.container) {
        return;
    }
    var container = picker.ui.container;
    if (container.dataset.gridBridgeBound) {
        return;
    }
    container.dataset.gridBridgeBound = 'true';
    container.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') {
            return;
        }
        var t = e.target;
        var onMonthButton = t && t.classList
            && (t.classList.contains('previous-button') || t.classList.contains('next-button'));
        if (!onMonthButton) {
            return;
        }
        var target = container.querySelector('.day.start, .day.end, .day.selected')
            || container.querySelector('.day.today')
            || container.querySelector('.day.unit:not(.locked):not(.not-available)');
        if (target) {
            e.preventDefault();
            e.stopPropagation();
            target.focus();
        }
    }, true);
}
